import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import axios from "axios";
import { apiUrl } from "../../../constants";
import Dropdown2 from "../dropdown2/Dropdown2";

const Section = ({ control, register, errors }) => {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/section`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentSection) => {
      const newOption = {
        label: currentSection.section,
        value: currentSection.section,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section className="section-wrapper">
      <div>
        <Controller
          control={control}
          name="section"
          render={({ field: { onChange, value } }) => (
            <Dropdown2
              label="Section"
              options={options}
              name="section"
              value={value}
              onChange={onChange}
              fieldRef={register("section", { required: false })}
            />
          )}
        />
      </div>
    </section>
  );
};

export default Section;
